import platforms from 'config/platforms'

const defaultNormalizer = hostname =>
  /^https?:\/\//.test(hostname) ? hostname : `https://${hostname}`

export default (hostname, clientId) => {
  const platform = platforms.find(platform => platform.id === clientId)
  const normalizer = (platform && platform.homeUrlFn) || defaultNormalizer

  return normalizer(hostname)
}



// WEBPACK FOOTER //
// ./src/utils/normalizeHostname.js